import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { DatePicker, Select } from 'ui/components';
import { formatDate } from 'utilities/common';

const initialState = {
  shipping_date: null,
  document_status: '',
  fulfillment_status: ''
};

const statusOptions = [
  { value: 'new', label: 'Baru' },
  { value: 'process', label: 'Dalam Proses' },
  { value: 'completed', label: 'Selesai' },
];

const fulfillmentStatusOptions = [
  { value: 'unprocess', label: 'Belum Diproses' },
  { value: 'fulfilled', label: 'Dalam Proses' },
  { value: 'disputed', label: 'Dispute' },
  { value: 'completed', label: 'Selesai' },
];

const Filter = ({ show, onClose, table, setCount }) => {
  const [{ shipping_date, document_status, fulfillment_status }, setState] = React.useState(initialState);

  const $onLoad = async () => {
    let sd = null
    if (table.State?.filter?.shipping_date) {
      sd = new Date(table.State?.filter?.shipping_date)
    }

    setState((prevState) => ({
      ...prevState,
      shipping_date: sd,
      status:
        table?.State?.filter?.document_status === 'new'
          ? statusOptions[0]
          : table?.State?.filter?.document_status === 'process'
          ? statusOptions[1]
          : table?.State?.filter?.document_status === 'completed'
          ? statusOptions[2]
          : null,
      fulfillment_status:
        table?.State?.filter?.fulfillment_status === 'unprocess'
          ? fulfillmentStatusOptions[0]
          : table?.State?.filter?.fulfillment_status === 'fulfilled'
          ? fulfillmentStatusOptions[1]
          : table?.State?.filter?.fulfillment_status === 'disputed'
          ? fulfillmentStatusOptions[2]
          : table?.State?.filter?.fulfillment_status === 'completed'
          ? fulfillmentStatusOptions[3]
          : null,
    }));
  };

  const handleFilter = async (e) => {
    if (table?.State?.filter) {
      let x = [];
      Object.keys(table?.State?.filter).forEach((k) => {
        if (
          table?.State?.filter[k] &&
          k !== 'start_at' &&
          k !== 'warehouse_id'
        ) {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const $filterStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      document_status: e,
    }));

    table?.filter('document_status', e?.value);
    handleFilter();
  };

  const $filterFulfillmentStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      fulfillment_status: e,
    }));

    table?.filter('fulfillment_status', e?.value);
    handleFilter();
  };

  const $handleShippingDate = (e) => {
    let filterDate = null
    if (e) {
      filterDate = formatDate(e, 'YYYY-MM-DD')
    }

    setState((prevState) => ({
      ...prevState,
      shipping_date: e,
    }));
    table.filter('shipping_date', filterDate);
    handleFilter();
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Jadwal Pengiriman
          </div>
          <DatePicker
            value={shipping_date}
            placeholder=""
            onChange={$handleShippingDate}
          />
        </div>
        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status Pengiriman
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={document_status}
            initialValue={document_status}
            options={statusOptions}
            onChange={$filterStatus}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status Fulfillment
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={fulfillment_status}
            initialValue={fulfillment_status}
            options={fulfillmentStatusOptions}
            onChange={$filterFulfillmentStatus}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>


          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Jadwal Pengiriman
            </div>
            <DatePicker
              value={shipping_date}
              placeholder=""
              onChange={$handleShippingDate}
            />
          </div>
          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status Pengiriman
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={document_status}
              initialValue={document_status}
              options={statusOptions}
              onChange={$filterStatus}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status Fulfillment
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={fulfillment_status}
              initialValue={fulfillment_status}
              options={fulfillmentStatusOptions}
              onChange={$filterFulfillmentStatus}
            />
          </div>

        </div>
      </>
    </>
  );
};

export default Filter;
